<template>
    <div>
        <!-- Breadcrumb Area -->
        <Breadcrumb mainTitle="User Data" breadContent="User Information Page" subTitle="User Data" />
        <div v-if="isLoggedIn">
            <div class="container background-color:#f9f9f9">
                <div class="user-profile">
                    <div v-if="isProfileInit">
                        <div class="profile-card">
                            <!-- Left Section: Profile Picture & Name -->
                            <div class="profile-left">
                                <img class="profile-picture" :src="user.picture" alt="User Profile Picture" />
                                <h2>{{ user.name }}</h2>
                                <h7>{{ user.bio }}</h7>
                            </div>

                            <!-- Right Section: User Information -->
                            <div class="profile-right">
                                <div class="info-section">
                                    <div class="info-box">
                                        <strong>Email</strong>
                                        <p>{{ user.email }}</p>
                                    </div>
                                    <div class="info-box phone-box">
                                        <strong>Phone</strong>
                                        <p>{{ user.phone }}</p>
                                    </div>
                                </div>

                                <div class="info-box location-box">
                                    <strong>Location</strong>
                                    <p><span style="font-weight: bold;">Address:</span> {{ user.address }}</p>
                                    <p><span style="font-weight: bold;">Longitude, Latitude:</span> {{ user.longitude }}
                                        N,
                                        {{ user.latitude }} W</p>

                                </div>

                                <div class="info-box location-box">
                                    <strong>Other Information</strong>

                                </div>
                                <!-- Form for registering a sensor -->
                                <form @submit.prevent="registerSensor">
                                    <input v-model="sensorInput" type="text" placeholder="Enter sensor details"
                                        class="sensor-input" required />
                                    <button class="edit-button" type="submit">Register Sensor</button>
                                </form>
                            </div>
                        </div>
                        <button class="edit-button" @click="editProfile">Edit Profile</button>
                    </div>

                    <div v-else-if="loaded">
                        <div class="profile-card">
                            Please set up your profile!
                        </div>
                        <button class="edit-button" @click="editProfile">Setup Profile</button>
                    </div>
                    <div v-else>
                        loading...
                    </div>

                </div>
            </div>
        </div>
        <div v-else>
            <p>Not Logged In</p>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, Pagination, A11y, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import Breadcrumb from '@/components/Breadcrumb.vue'

import Session, { doesSessionExist } from 'supertokens-web-js/recipe/session';

let apiDomain = "http://localhost:3000";

export default {
    components: {
        Swiper,
        SwiperSlide,
        Breadcrumb
    },
    data() {
        return {
            // TODO need to update this to fetch data properly
            isLoggedIn: null,
            isProfileInit: null,
            loaded: false,
            user: {
                name: null,
                email: null,
                bio: "N/A",
                picture: "https://via.placeholder.com/150",
                address: "N/A",
                phone: "N/A",
                latitude: "N/A",
                longitude: "N/A"
            }
        };
    },
    async mounted() {
        if (await Session.doesSessionExist()) {
            // user is logged in
            console.log("logged in");
            this.isLoggedIn = true;
            let userInfoResponse = await axios.get(apiDomain + "/get_user_info");
            this.user.email = userInfoResponse.data.email;
            if (userInfoResponse.data.info.status == "Created") {
                this.isProfileInit = true;
                this.user.name = "" + userInfoResponse.data.info.lname + ", " + userInfoResponse.data.info.fname
                this.user.address = "" + userInfoResponse.data.info.address + ", " + userInfoResponse.data.info.city + ", " + userInfoResponse.data.info.state
                this.user.phone = userInfoResponse.data.info.phone_number
                this.user.latitude = userInfoResponse.data.info.latitude
                this.user.longitude = userInfoResponse.data.info.longitude
            }
            else {
                this.isProfileInit = false;
            }
        } else {
            // user has not logged in yet
            console.log("no login yet");
            this.isLoggedIn = false;
        }
        this.loaded = true;
    },
    methods: {
        editProfile() {
            alert("in progress"); // Currently a placeholder
        },
        async registerSensor() {
            try {
                const userCode = this.sensorInput;

                // Send a POST request to the API
                const response = await fetch(`${apiDomain}/register_sensor?user_code=` + encodeURIComponent(userCode), {
                    method: "POST",
                    credentials: "include", // Include session cookies 
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        user_code: this.sensorInput, // Send data in the body
                    }),
                });

                const data = await response.json();

                // Handle the response
                if (data.status === "InvalidCode") {
                    alert("Invalid activation code. Please try again.");
                } else {
                    alert(data.status); // Success message
                    this.sensorInput = "";
                }
            } catch (error) {
                console.error("Error registering sensor:", error);
                alert("Failed to register sensor. Please check the activation code or try again.");
            }
        },
    }
};
</script>

<style scoped>
.user-profile {
    display: flex;
    flex-direction: column;
    align-items: left;
    width: 100%;
    padding: 20px;
}

.profile-card {
    display: flex;
    align-items: center;
    width: 100%;
    background-color: #f9f9f9;
    padding: 20px;
    border-radius: 8px;
    border: 1px solid #ddd;

}

.profile-left {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 300px;
    margin: 10px;
}

.profile-picture {
    border-radius: 50%;
    width: 120px;
    height: 120px;
    margin-bottom: 10px;
    align-items: center;
}

.profile-right {
    display: flex;
    flex-direction: column;
    justify-content: left;
    width: 100%;
}

.info-section {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
}

.info-box {
    border: 1px solid #ddd;
    padding: 15px;
    border-radius: 8px;
    background-color: #ffffff;
    flex-grow: 1;
}

.info-box strong {
    display: block;
    margin-bottom: 10px;
    color: #333;
}

.info-box p {
    margin: 0;
    color: #666;
}

.location-box {
    margin-bottom: 20px;
}

h2 {
    margin: 10px 0;
}

.edit-button {
    background-color: #FF7129;
    color: white;
    border: none;
    padding: 10px 10px;
    border-radius: 5px;
    cursor: pointer;
    margin: 20px;
}

.edit-button:hover {
    background-color: #63BE61;
}

.sensor-input {
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    margin-right: 10px;
    width: 200px;
}
</style>